import './TextEllipsis.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var active = '_1mnpbqs0-3-8-0';
export var ellipsis = _7a468({defaultClassName:'_1mnpbqs1-3-8-0',variantClassNames:{truncationMode:{start:'_1mnpbqs2-3-8-0',middle:'_1mnpbqs3-3-8-0',end:'_1mnpbqs4-3-8-0'}},defaultVariants:{},compoundVariants:[]});